import { useState } from "react";

import { HatcheryRain } from "./HatcheryRain";

export const TheHatchery: React.FC = () => {
  const [count, setCount] = useState(0);
  return (
    <>
      <span
        onClick={() => setCount((c) => c + 1)}
        className="cursor-pointer hover:text-text-secondary transition-colors"
      >
        The Hatchery
      </span>
      {count > 0 && <HatcheryRain key={count} onComplete={() => {}} />}
    </>
  );
};
